import $ from 'jquery';
import Modernizr from 'modernizr';
import jump from 'jump.js';
import './modules/_skip-link-focus-fix';
import './modules/_menus';
import 'jquery-match-height';
import Request from 'superagent';

/**
 * Notes:
 *
 * Although jQuery is imported above, it is not bundulded
 * with the transpiled assets. jQuery needs to be global
 * on the website.
 *
 * All imports belong at the top of the file.
 *
 * Webpack only outputs this one script file, if you need
 * another file then add it to the scripts-list.js file as
 * another line in the scripts_list object.
 *
 * The scripts_list const is imported into the webpack
 * config. I've done this so that you do not have to
 * wade through the consfig to find what is being
 * compiled out as its own file.
 */

const alertUrl = 'api/NotificationSet/_execute';

/*************** Match Height ***************/
$('.match-height').matchHeight();

/*************** SVG image replacement ***************/
if(!Modernizr.svg) {
	$('img[src*="svg"]').attr('src', function() {
		return $(this).attr('src').replace('.svg', '.png');
	});
}

/*************** Flex Video ***************/
$('iframe[src*="player.vimeo.com"],[src*="www.youtube.com"],object[id="flashObj"]').each(function() {
	if (!$(this).parent().hasClass('flex-video')) {
		$(this).wrap('<div class="flex-video widescreen"/>');
	}
});

/*************** Search region ***************/
$('.search-button a').on('click', function(event) {
	event.preventDefault();

	$('.search-region').slideToggle(function() {
		$('.search-field').focus();
	});
});

/*************** Scroll to top ***************/
let scroll_distance;
const back_to_top = $('#scroll_top');

$(document).scroll(function() {
	scroll_distance = $(window).scrollTop();

	if ( scroll_distance >= 205 ) {
		back_to_top.addClass('show');
	} else {
		back_to_top.removeClass('show');
	}
});

back_to_top.on('click', function(event){
	event.preventDefault();

	jump('#contentstart');
});

$('body').on('click', '.download-link', function(){
	var src = $(this).data('src');
	if ((src !== null) && (src !== '')){
		if (src.includes('/')){
			Request
				.post('/api/Document/_execute')
				.use((req) => {
					req.header.contentType = 'application/json';
					req.header.RequestVerificationToken = $('#__RequestVerificationToken').val();
					return req;
				})
				.send({
					'$type' : 'Asi.Soa.Core.DataContracts.GenericExecuteRequest, Asi.Contracts',
					'EntityTypeName' : 'Document',
					'OperationName' : 'FindByPath',
					'Parameters' : {
						'$type' : 'System.Collections.ObjectModel.Collection`1[[System.Object, mscorlib]], mscorlib',
						'$values' : [
							{
								'$type' : 'System.String',
								'$value' : src
							}
						]
					},
					'UseJson':false,
					'ParameterTypeNames':{
						'$type':'System.Collections.ObjectModel.Collection`1[[System.String, mscorlib]], mscorlib',
						'$values':[
							'System.String'
						]
					}
				})
				.then(res => {
					if (res && res.body){
						processDocument(res.body);
					}else{
						alert('Error: Documnent can\'t be found');
					}
				});
		}

	}
});

function processDocument(item){
	var contentType = 'application/octet-stream';
	var success = false;
	var filename = item.Name;

	try
	{
		// Try using msSaveBlob if supported
		let blob = new Blob([item.Data], { type: contentType });
		if(navigator.msSaveBlob)
			navigator.msSaveBlob(blob, filename);
		else {
			// Try using other saveBlob implementations, if available
			var saveBlob = navigator.webkitSaveBlob || navigator.mozSaveBlob || navigator.saveBlob;
			if(saveBlob === undefined) throw 'Not supported';
			saveBlob(blob, filename);
		}
		success = true;
	} catch(ex) {
		//eslint-disable-next-line no-console
		console.error('saveBlob method failed with the following exception:');
		//eslint-disable-next-line no-console
		console.error(ex);
	}

	if(!success)
	{
		// Get the blob url creator
		var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
		if(urlCreator)
		{
			// Try to use a download link
			var link = document.createElement('a');
			if('download' in link)
			{
				// Try to simulate a click
				try
				{
					// Prepare a blob URL
					let blob = new Blob([item.Data], { type: contentType });
					let url = urlCreator.createObjectURL(blob);
					link.setAttribute('href', url);

					// Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
					link.setAttribute('download', filename);

					// Simulate clicking the download link
					var event = document.createEvent('MouseEvents');
					event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
					link.dispatchEvent(event);
					success = true;

				} catch(ex) {
					//eslint-disable-next-line no-console
					console.error('Download link method with simulated click failed with the following exception:');
					//eslint-disable-next-line no-console
					console.error(ex);
				}
			}

			if(!success)
			{
				// Fallback to window.location method
				try
				{
					// Prepare a blob URL
					// Use application/octet-stream when using window.location to force download
					let blob = new Blob([item.Data], { type: contentType });
					let url = urlCreator.createObjectURL(blob);
					window.location = url;
					success = true;
				} catch(ex) {
					//eslint-disable-next-line no-console
					console.error('Download link method with window.location failed with the following exception:');
					//eslint-disable-next-line no-console
					console.error(ex);
				}
			}

		}
	}

	if(!success)
	{
		// Fallback to window.open method
		alert('Error downloading document!');
	}
}

/* eslint-disable */
$('a[data-trigger]').on('click', function (e) {
	if (typeof gtag !== 'undefined'){
		e.preventDefault();
		var label = $(this).data('trigger');
    	var linkUrl = $(this).attr('href');
		var newWindow = ($(this).attr('target') && (($(this).attr('target') == 'blank') || ($(this).attr('target') == '_blank'))) ? true : false;
		gtag('event', 'click', {'event_category': label, 'event_label': linkUrl, 'transport_type': 'beacon', 'event_callback': function(){
			if (newWindow)
			{
				window.open(linkUrl, '_blank');
			}
			else
			{
				window.location = linkUrl;
			}
		}});
	}
});
/* eslint-enable */

$(document).ready(function() {
	let context = JSON.parse($('#__ClientContext').val());
	$('a').each(function() {
		var link = $(this).attr('href');
		if (link && ( ( link.indexOf('http') === 0 ) || ( link.indexOf( '/' ) === 0 ) ) ){
			link = link.replace(/\[([^\]]+)]/g, filterQuerystring);
			$(this).attr('href', link);
		}
	});

	$('div[data-alert]').each(function(){
		var that = this;
		var alertData = $(that).data('alert');
		//eslint-disable-next-line quotes
		var alertParams = JSON.parse(alertData.replace(/\\'/g, '"'));
		if (alertParams && alertParams.hasOwnProperty('rule')) {
			var ruleValue = filterQuerystring('', alertParams.rule.key, '', '');
			if (ruleValue !== null && alertParams.rule.value.toLowerCase() === ruleValue.toLowerCase()) {
				Request.post(context.baseUrl + alertUrl)
					.use((req) => {
						req.header.contentType = 'application/json';
						req.header.RequestVerificationToken = $(
							'#__RequestVerificationToken'
						).val();
						return req;
					})
					.send({
						'$type':
							'Asi.Soa.Communications.DataContracts.NotificationSetRequest, Asi.Contracts',
						'EntityTypeName': 'NotificationSet',
						'OperationName': 'NotificationSetRequest',
						'Operation': {
							'$type':
								'Asi.Soa.Communications.DataContracts.NotificationSetOperationData, Asi.Contracts',
						},
						'NotificationSetId': alertParams.Id,
						'PartyId': context.selectedPartyId,
						'ParametersString': window.location.search,
					})
					.then((res) => {
						if (res && res.body) {
							$(that)
								.empty()
								.html(res.body)
								.removeClass('hide')
								.show();
						}
					});
			}
		}
	});
});

function filterQuerystring(match, p1, offset, s) {
	let href = window.location.href;
	let reg = new RegExp('[?&]' + p1 + '=([^&#]*)', 'i');
	let string = reg.exec(href);
	return string ? string[1] : null;
}


// WEBPACK FOOTER //
// ./theme_components/js/global-scripts.js